import { Dialog } from 'components/ui'
import { useDispatch, useSelector } from 'react-redux'
import { setDialogOpen } from 'store/header/headerSlice'
import CityForm from './component/CityForm'

const CityDialog = () => {
    const dispatch = useDispatch()
    const open = useSelector((state) => state.header.city)
    console.log('headerOpen', open)
    const onDialogClose = () => {
        dispatch(setDialogOpen(false))
    }
    return (
        <Dialog
            className="lg:w-3/5 w-2/5"
            isOpen={open.openCityFormDialog}
            onClose={onDialogClose}
            onRequestClose={onDialogClose}
        >
            <h5 className="mb-4">Add City</h5>
            <CityForm />
        </Dialog>
    )
}
export default CityDialog
